import { useIntl } from 'react-intl';

import { Typography } from '@/components/Typography';
import { commonMessages } from '@/messages/common';

import { ReactComponent as PlanYourGiftIcon } from '@/assets/4gift-plan-your-gift.svg';

import * as S from '../SendGiftModal.styles';

export const PlanYourGift = () => {
  const { formatMessage } = useIntl();
  return (
    <S.InfoBoxBody>
      <PlanYourGiftIcon />
      <Typography
        fontFamily='italianPlate'
        fontWeight='bold'
        mb='s035'
        mt='s035'
        scale='p0'
        textTransform='uppercase'
      >
        {formatMessage(commonMessages.sendGiftPlanGift)}
      </Typography>
      <Typography textAlign='center'>
        {formatMessage(commonMessages.sendGiftPlanGiftDesc)}
      </Typography>
    </S.InfoBoxBody>
  );
};
